import { Button } from '@eppendorf/vnls-react-components';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

export enum AuditEventCategory {
  All = 'all',
  Device = 'device',
  Event = 'event',
  Notification = 'notification',
  User = 'user',
  Platform = 'platform',
}

export const AUDIT_EVENT_CATEGORIES = Object.values(AuditEventCategory);

interface AuditEventsCategoryFilterProps {
  selectedCategory: AuditEventCategory;
  onCategoryChange: (category: AuditEventCategory) => void;
  className?: string;
}

export function AuditEventsCategoryFilter({
  selectedCategory,
  onCategoryChange,
  className,
}: AuditEventsCategoryFilterProps) {
  const { t } = useTranslation();

  const categoryLabels = new Map<AuditEventCategory, string>([
    [AuditEventCategory.All, t('auditEvents.categories.all')],
    [AuditEventCategory.Device, t('auditEvents.categories.device')],
    [AuditEventCategory.Event, t('auditEvents.categories.event')],
    [AuditEventCategory.Notification, t('auditEvents.categories.notification')],
    [AuditEventCategory.User, t('auditEvents.categories.user')],
    [AuditEventCategory.Platform, t('auditEvents.categories.platform')],
  ]);

  // currently the category filter doesn't have a checkmark for the selected category. To be implemented in the future if it's still needed.
  return (
    <div className={cn('flex gap-s', className)}>
      {AUDIT_EVENT_CATEGORIES.map((category) => {
        const isSelected = selectedCategory === category;
        return (
          <Button
            key={category}
            variant={isSelected ? 'primary' : 'outline'}
            onClick={() => onCategoryChange(category)}
            size="pill"
            className={!isSelected ? 'bg-white' : ''}
          >
            <span className="font-size-s">{categoryLabels.get(category)}</span>
          </Button>
        );
      })}
    </div>
  );
}
